import { render, staticRenderFns } from "./VideoChatInvitation.Dialog.vue?vue&type=template&id=1d2764c4&scoped=true"
import script from "./VideoChatInvitation.Dialog.vue?vue&type=script&lang=js"
export * from "./VideoChatInvitation.Dialog.vue?vue&type=script&lang=js"
import style0 from "./VideoChatInvitation.Dialog.vue?vue&type=style&index=0&id=1d2764c4&prod&lang=css&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d2764c4",
  null
  
)

export default component.exports